import axios from "axios";
import { readRefreshToken, readToken, storeToken } from "Helpers/Token";
import showNotify from "Helpers/Notify";
import { baseURL } from "./ApiSettings";
import { read, store } from "Helpers/LocalStorage";
import { push } from "../../Helpers/History";
import { translatorf } from "Languages/Utility/translatorf";

/** HTTP Service witch created by Axios instance creator
 * @abstract
 * */
class BaseApi {
  constructor({ suffix, baseUrl = baseURL }) {
    this.httpService = axios.create({
      baseURL: `${baseUrl}${suffix ? `/${suffix}` : ""}`,
      timeout: 500000,
    });
    this.requestInterceptors();
    this.responseInterceptors();
  }

  requestInterceptors() {
    this.httpService.interceptors.request.use(
      async (request) => {
        if (
          !request.headers.Authorization ||
          request.headers.Authorization === "Bearer undefined"
        ) {
          const token = `Bearer ${readToken()}`;
          if (token) {
            request.headers.Authorization = token;
          }
        }
        return request;
      },
      (error) => Promise.reject(error)
    );
  }

  responseInterceptors() {
    //Intercept responses before they are handle by then or catch
    this.httpService.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        const originalRequest = error.config;
        if (error.response && error.response.status === 401) {
          //createAuthRefreshInterceptor(instance, refreshAuthLogic);
          const params = {
            TokenKey: read("userKey"),
            TokenRef: readRefreshToken(),
          };
          return axios
            .get(baseURL + "/Accounts/get-token-with-refresh-token", { params })
            .then((response) => {
              if (response) {
                const { data } = response;
                if (data["StatusCode"] === 200) {
                  storeToken(data.Value.Token, data.Value["RefreshToken"]);
                  window.location.reload();
                  return null;
                  // originalRequest.headers.Authorization = `Bearer ${data.Value.Token}`;
                  // return this.httpService(originalRequest);
                } else if (data["StatusCode"] === -2) {
                  localStorage.clear();
                  window.location.reload();
                }
              }
            })
            .catch((err) => {
              localStorage.clear();
              window.location.reload();
            });
        } else if (error.response?.status === 400) {
          showNotify({
            text: translatorf('API_ERR_WrongData'),
            customClass: "error",
          });
        } else if (!error.response) {

          // network error
          showNotify({
            text: translatorf('API_ERR_NoInternet'),
          });
        } else if (
          error.response &&
          error.response.status > 401 &&
          error.response.status < 500
        ) {
          //Bad Request
          //404 Not Found
          showNotify({
            text: translatorf('API_ERR_SomeError'),
          });
        } else if (
          error.response &&
          error.response.status === 988
        ) {
          showNotify({
            text: translatorf('API_ERR_ManyReqInSec'),
            customClass: "error",
          });
        } else {
          console.log(error);
          //error 500
          showNotify({
            text: translatorf('API_ERR_ServerErr'),
          });
        }
        return error.response;
        // return Promise.reject(error);
      }
    );
  }
}

export default BaseApi;
